class ClangJS {
  onReady;
  readyResolve;
  writeCallback;

  constructor(path, _writeCallback) {
    this.nextResponseId = 0;
    this.responseCBs = new Map();
    this.worker = new Worker(new URL("./worker.js", import.meta.url));
    const channel = new MessageChannel();
    this.port = channel.port1;
    this.port.onmessage = this.onmessage.bind(this);
    this.writeCallback = _writeCallback;

    const remotePort = channel.port2;
    this.worker.postMessage(
      {
        id: "constructor",
        payload: {
          port: remotePort,
          path,
        },
      },
      [remotePort],
    );
    this.onReady = new Promise((resolve) => {
      this.readyResolve = resolve;
    });
  }

  setShowTiming(value) {
    this.port.postMessage({ id: "setShowTiming", payload: value });
  }

  terminate() {
    this.worker.terminate();
  }

  async runAsync(id, options) {
    const responseId = this.nextResponseId++;
    const responsePromise = new Promise((resolve, reject) => {
      this.responseCBs.set(responseId, { resolve, reject });
    });
    this.port.postMessage({ id, responseId, payload: options });
    return await responsePromise;
  }

  compile(code, options) {
    this.port.postMessage({ id: "compile", payload: { code, options } });
  }

  link(obj, out, options) {
    this.port.postMessage({
      id: "link",
      data: {
        obj,
        out,
        options,
      },
    });
  }

  execute(out, params) {
    this.port.postMessage({ id: "execute", payload: { out, params } });
  }

  run(code, stdin, name) {
    this.port.postMessage({ id: "run", payload: { code, stdin, name } });
  }

  onmessage(event) {
    switch (event.data.id) {
      case "ready":
        this.readyResolve();
        break;
      case "write":
        this.writeCallback(event.data.data);
        //console.log(event.data.data);
        break;
      case "runAsync": {
        const responseId = event.data.responseId;
        const promise = this.responseCBs.get(responseId);
        if (promise) {
          this.responseCBs.delete(responseId);
          promise.resolve(event.data.data);
        }
        break;
      }
    }
  }
}

export { ClangJS };
